import script from "./input-date-picker.vue?vue&type=script&setup=true&lang=js"
export * from "./input-date-picker.vue?vue&type=script&setup=true&lang=js"

import "./input-date-picker.vue?vue&type=style&index=0&id=db84fe10&lang=css"

const __exports__ = script;

export default __exports__